import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect () {
    requestAnimationFrame(() => {
      if (this.isFullyVisible()) return

      this.element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    })
  }

  isFullyVisible () {
    const rect = this.element.getBoundingClientRect()

    return rect.top >= 0 && rect.bottom <= window.innerHeight
  }
}
